import { Table } from '@datum-group/isogd-openapi/lib';
import { Filter } from '@project/store/shared/LayersTree/Tree/Filter';
import { AxiosInstance } from 'axios';

export interface CartogramsResponse {
  count: number;
  next?: string;
  previous?: string;
  results: Table[];
}

export class APICartograms {
  readonly url = '/api/cartograms/';

  constructor(private _axios: AxiosInstance) {}

  async list(filter?: Filter): Promise<CartogramsResponse> {
    const response = await this._axios.get<CartogramsResponse>(this.url, {
      params: { ...filter?.query },
    });

    // @ts-ignore
    return response.data;
  }
}
